import { createFileRoute } from '@tanstack/react-router'
import { TemplateDetailPage } from '@/features/admin/templates/detail'

export const Route = createFileRoute('/_admin/admin/templates/$templateId/')({
  component: TemplateDetailPage,
})
